import axios from 'axios'

const serverIp = 'cloud.liveabc.com'
const appPath = '/api'
export const apiPath = `https://${serverIp}${appPath}`
const api = axios.create({
  baseURL: apiPath,
  timeout: 1000 * 60 * 60,
  headers: {
    'access-control-allow-origin': '*',
    'Content-Type': 'application/json',
  },
})
api.interceptors.request.use(request => {
  const token = localStorage.getItem('authorizedAIToken')

  if (!request.headers) {
    request.headers = {}
  }

  if (token) {
    request.headers['Authorization'] = `Bearer ${token}`
  }

  axios.defaults.withCredentials = false

  return request
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status } = error.response
      if (status === 401) {
        // localStorage.removeItem('authorizedAIToken')
        // window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

export default api
